export default __webpack_public_path__ + "static/media/poster.41df65be.png";